import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * Data item class for the IMAGE data type. Data items in shape models with the IMAGE
 * data type will be deserialized into instances of this class by the `DataItemFactory`.
 */
export class LookupDataItem extends AbstractDataItem<DataType.LOOKUP> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof LookupDataItem.prototype.value ): IValidationError {
        if ( value === undefined ) {
            return null;
        }
        if ( Array.isArray( value )) {
            return null;
        }
        return { message: `"${value}" is not a valid lookup value` };
    }
}
